<template>
    <div class="appointment-info">
        <div class="info-header" @click="changeState('isAppointmentInfoShow')">
            <div class="info-header-left">
                <span class="info-header-block"></span>
                <span class="info-header-text">仓库预约信息</span>
            </div>
            <i :class="['el-icon', 'mgr-10', isAppointmentInfoShow ? 'el-icon-arrow-down' :'el-icon-arrow-right']"></i>
        </div>
        <div class="appointment-wrapper" v-show="isAppointmentInfoShow">
            <el-table
                border
                max-height="200"
                style="width:100%"
                :data="loadBookList"
                @cell-dblclick="cellDblClick"
            >
                <el-table-column
                    v-for="(column, index) in tableProp"
                    :key="index"
                    :min-width="column.width"
                    :label="column.label"
                    :prop="column.prop"
                    :show-overflow-tooltip="true"
                ></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import { copyToClip } from '../util';
export default {
    name: 'AppointmentInformation',
    props: {
        loadBookList: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            isAppointmentInfoShow: true,
            tableProp: [
                {
                    label: '序号',
                    prop: 'tableIndex',
                    width: '80px'
                },
                {
                    label: '预约分类',
                    prop: 'bookTypeName',
                    width: '150px'
                },
                {
                    label: '仓库名称',
                    prop: 'whName',
                    width: '230px'
                },
                {
                    label: '预约状态',
                    prop: 'bookStatusName',
                    width: '150px'
                },
                {
                    label: '预约人',
                    prop: 'bookingUserName',
                    width: '150px'
                },
                {
                    label: '预约时间',
                    prop: 'bookingTime',
                    width: '150px'
                },
                {
                    label: '预约模式',
                    prop: 'bookingModeName',
                    width: '150px'
                },
                {
                    label: '线路时刻表时间',
                    prop: 'lineTime',
                    width: '150px'
                },
                {
                    label: '加急状态',
                    prop: 'urgentStatusName',
                    width: '150px'
                },
                {
                    label: '加急原因',
                    prop: 'reason',
                    width: '150px'
                },
                {
                    label: '加急操作人',
                    prop: 'urgentUserName',
                    width: '150px'
                },
                {
                    label: '操作加急时间',
                    prop: 'urgentOpeTime',
                    width: '150px'
                }
            ]
        };
    },
    methods: {
        changeState (state) {
            this[state] = !this[state];
        },
        cellDblClick (row, column, cell, event) {
            if (row[column.property] === null || row[column.property] === undefined) return;
            const value = row[column.property];
            copyToClip(value);
        }
    }
};
</script>

<style lang="less" scoped>
@import '../dispatchInfoDetail.less';
.appointment-info {
    background-color: #fff;
    margin-bottom: 10px;
}
.appointment-wrapper {
    padding: 10px;
}
</style>
